export const RENT_CANCEL = 'Annulé';
export const RENT_ENDED = 'Terminé';
export const RENT_EXTENDED = 'Prolongé';
export const RENT_IN_PROGRESS = 'En cours';



// WEBPACK FOOTER //
// ./src/constants/RentStates.js